import { Button } from 'antd';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import DefaultPageHeaderButton from 'components/buttons/DefaultPageHeaderButton';
import { useLogoutWithAppClear } from 'hooks/useLogoutWithAppClear';
import trackEvent from 'store/modules/tracking/actions';
import { EventType } from 'store/modules/tracking/types';

interface Props {
  isPageHeaderExtra?: boolean;
}

export function useLogOutButtonClick(buttonLocation: string): () => void {
  const dispatch = useDispatch();
  const logoutWithAppClear = useLogoutWithAppClear();

  return useCallback(() => {
    dispatch(
      trackEvent({
        type: EventType.LOG_OUT,
        data: { status: true, buttonLocation }
      })
    );
    logoutWithAppClear();
  }, [buttonLocation, dispatch, logoutWithAppClear]);
}

function LogOutButton({ isPageHeaderExtra }: Props): React.ReactElement {
  const handleClick = useLogOutButtonClick('Settings Page');

  if (isPageHeaderExtra) {
    return (
      <DefaultPageHeaderButton onClick={handleClick}>
        LOG OUT
      </DefaultPageHeaderButton>
    );
  }

  return (
    <Button type="primary" onClick={handleClick}>
      LOG OUT
    </Button>
  );
}

export default LogOutButton;
